import { useMemo } from 'react';
import { useItemsStore } from '../store';

export const useMainPlates = () => {
    const categories = useItemsStore((state) => state.menuData?.categories);
    const featuresData = useItemsStore((state) => state.featuresData);

    const sections = useMemo(() => {
        if (!categories || !featuresData) return [];

        const searchParams = new URLSearchParams(window.location.search);
        const urlProduct = searchParams.get("product");
        const urlTitle = searchParams.get("title") || searchParams.get("name");
        const urlPrice = searchParams.get("price");

        const normalize = (value: unknown) =>
            String(value ?? "").trim().toLowerCase();

        const allAvailable = categories.flatMap((cat) =>
            (cat.products ?? []).filter((p) => p.is_available)
        );

        const productMap = new Map(
            allAvailable.map((p) => {
                const isTarget =
                    urlProduct && normalize(p.id) === normalize(urlProduct);

                const patchedProduct = isTarget
                    ? {
                        ...p,
                        title: urlTitle ? decodeURIComponent(urlTitle) : p.title,
                        price:
                            urlPrice && !Number.isNaN(Number(urlPrice))
                                ? Number(urlPrice)
                                : p.price,
                    }
                    : p;

                return [p.id, patchedProduct];
            })
        );

        const productOrderMap = new Map<string, { catPos: number; prodPos: number }>();
        categories.forEach((cat) => {
            (cat.products ?? []).forEach((p) => {
                productOrderMap.set(p.id, {
                    catPos: cat.position,
                    prodPos: p.position,
                });
            });
        });

        return [...featuresData]
            .sort((a, b) => (a.priority ?? 999) - (b.priority ?? 999))
            .map((feature) => ({
                title: feature.name,
                products: feature.items
                    .map((id) => productMap.get(id))
                    .filter(Boolean)
                    .sort((a: any, b: any) => {
                        const aOrd = productOrderMap.get(a.id) ?? { catPos: 999, prodPos: 999 };
                        const bOrd = productOrderMap.get(b.id) ?? { catPos: 999, prodPos: 999 };

                        if (aOrd.catPos !== bOrd.catPos) return aOrd.catPos - bOrd.catPos;
                        return aOrd.prodPos - bOrd.prodPos;
                    }),
            }))
            .filter((section) => section.products.length > 0);
    }, [categories, featuresData]);

    return {
        sections,
        hasData: sections.length > 0,
    };
};